'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkTechItem.module.css';

export function DevlinkTechItem({
  as: _Component = _Builtin.Block,
  showImageSource = true,
  imageSource = 'https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6604b9305adbc337f3ff0593_glenn_0cb55c2559f3115a8a0e1a5180a2ec47.png',
  showImageSlot = true,
  imageSlot,
  techName = 'GlennH.',
  techSubtext = 'TVand AVMounting Specialist',
  techBody = "I love helping people solve their tech problems as well as helping them understand the issue so it doesn't happen again!",
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'align-center')}
      id={_utils.cx(_styles, 'w-node-f5571640-c809-62eb-3ba3-d1134713f9a6-4713f9a6')}
      tag="div"
    >
      {showImageSlot ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-meet-tech-item-img')} tag="div">
          {imageSlot}
        </_Builtin.Block>
      ) : null}
      {showImageSource ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-meet-tech-item-img')} tag="div">
          <_Builtin.Image className={_utils.cx(_styles, 'ht-inner-img')} loading="lazy" width="auto" height="auto" alt="" src={imageSource} />
        </_Builtin.Block>
      ) : null}
      <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
      <_Builtin.Block className={_utils.cx(_styles, 'txt-subheader')} tag="div">
        {techName}
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, 'tiny')} tag="div" />
      <_Builtin.Block className={_utils.cx(_styles, 'txt-body-sm')} tag="div">
        {techSubtext}
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
      <_Builtin.Block tag="div">
        <_Builtin.Paragraph className={_utils.cx(_styles, 'ht-meet-tech-item-text')}>{'"'}</_Builtin.Paragraph>
        <_Builtin.Paragraph className={_utils.cx(_styles, 'ht-meet-tech-item-text')}>{techBody}</_Builtin.Paragraph>
        <_Builtin.Paragraph className={_utils.cx(_styles, 'ht-meet-tech-item-text')}>{'"'}</_Builtin.Paragraph>
      </_Builtin.Block>
    </_Component>
  );
}
